module Meevo.Plugins.DrawerManager {
    "use strict";

    export class DrawerClosedSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        protected canOpen: boolean = true;
        protected canUndoPreviousClose: boolean = true;

        constructor(
            drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean
        ) {
            super(DrawerManager.DrawerManagerSectionTypeEnum.DrawerClosed, drawerManagerContext, "drawerClosed", personalHeader, personalFooter);
        }

        reset() {
            super.reset();
            this.canOpen = true;
            this.canUndoPreviousClose = true;
        }

        initialize(canOpen?: boolean, canUndoPreviousClose?: boolean) {
            if (_.isBoolean(canOpen)) {
                this.canOpen = canOpen;
            }

            if (_.isBoolean(canUndoPreviousClose)) {
                this.canUndoPreviousClose = canUndoPreviousClose;
            }
        }

        getSectionName() {
            return this.context.selectedDrawer.displayName + " - Closed";
        }

        getState(): any {
            return { canOpen: this.canOpen, canUndoPreviousClose: this.canUndoPreviousClose };
        }

        setState(state: any) {
            if (state != null) {
                this.initialize(state.canOpen, state.canUndoPreviousClose);
            }
        }

        reopenDrawer() {
            this.context.reopenDrawerSession().then(() => {
                if (this.context.insideRegister) {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_OPENED, { name: "register" });
                }

                this.context.replaceOpenSection(DrawerManagerSectionTypeEnum.DrawerOpened, DrawerManagerSectionTypeEnum.DrawerClosed);
            });

            // minimize payload
            let payload = _.clone(this.context.selectedDrawer.drawerSession);
            payload.drawerSessionHistory = null;
            // Duplicate. Exist in register logic
            //this.dataService.trackUsage(Model.NounEnum.Drawer, Model.VerbEnum.UndoPreviousClose, JSON.stringify(payload), this.context.selectedDrawer.drawerSession.drawerId);
        }

        getLatestOpeningNote() {
            return this.context.getLastDrawerSessionNote(Model.DrawerStateEnum.Open);
        }

        getLatestClosingNote() {
            return this.context.getLastDrawerSessionNote(Model.DrawerStateEnum.Close);
        }

        isEditClosingVisible(): boolean {
            const drawerSessionHistory = this.context.getDrawerSessionHistory() || [];
            return drawerSessionHistory.length > 1;
        }

        isUndoPreviousCloseVisible(): boolean {
            const drawerSessionHistory = this.context.getDrawerSessionHistory() || [];
            return drawerSessionHistory.length > 1;
        }

        isUndoPreviousCloseDisabled(): boolean {
            if (this.context.isPastTransactionMode()) {
                return true;
            }

            return !this.canUndoPreviousClose;
        }

        isOpenDrawerDisabled(): boolean {
            if (this.context.isPastTransactionMode()) {
                return true;
            }

            return !this.canOpen;
        }

        refresh() {
            this.context.getDrawerSession(this.context.selectedDrawer.id, true, this.context.selectedDrawer.drawerSession.id, true);
        }
    }
}